export default "__VITE_ASSET__BlNWjJHl__"